// extracted by mini-css-extract-plugin
export default {"btnicon":"index_btnicon__BhTr6"};